import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { useRef, useState, useEffect, memo } from "react";

const EllipsisTooltipCount = ({ children, className = "",title='',count=0,moreButtonShowCount=1,tooltipClassName='',delayDuration=200,skipDelayDuration=0,showDisplayCount=false,displayCount=0,countClassName='', containerRef, ...props }) => {
  const textRef = useRef(null);
  const [isOverflowed, setIsOverflowed] = useState(false);

useEffect(() => {
  const el = textRef.current;
  if (!el) return;

  const checkOverflow = () => {
    setIsOverflowed(el.scrollWidth > el.clientWidth);
  };

  checkOverflow();

  const observer = new ResizeObserver(checkOverflow);
  observer.observe(el);

  return () => {
    observer.disconnect();
  };
}, [children]);
  return (
    <TooltipProvider  delayDuration={delayDuration} skipDelayDuration={skipDelayDuration}>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            className={cn(
              "block truncate max-w-full whitespace-nowrap overflow-hidden text-ellipsis font-sans",
              className
            )}
            style={{...props?.style,...props?.sx}}
            {...props}
          >
            <div className="flex items-center gap-2 min-w-0">
                <p className="flex-1 min-w-0 truncate text-sm" ref={textRef}>
                  {title}
                </p>
                {count > moreButtonShowCount && (
                  <span className={cn("flex items-center justify-center w-6 h-6 text-xs font-medium border dark:border-none bg-gray-100 text-gray-800 dark:bg-gray-600 dark:text-form-label rounded-full shrink-0",countClassName)}>
                    +{showDisplayCount ? displayCount : count}
                  </span>
                )}
              </div>
          </div>
        </TooltipTrigger>
        {(isOverflowed || count >moreButtonShowCount) && <TooltipContent containerRef={containerRef} className={cn("bg-muted-foreground rounded-[5px] max-h-[--radix-popper-available-height] overflow-auto",tooltipClassName)}>{typeof children === "function" ? children(isOverflowed) : children}</TooltipContent>}
      </Tooltip>
    </TooltipProvider>
  );
};

export default memo(EllipsisTooltipCount);
